module.exports = __webpack_public_path__ + "img/Wanita.a55dab4b.svg";